module.exports = __webpack_public_path__ + "img/icon-pfeil-slider_rechts_weiss.3ce8da1a.svg";